<template>
  <div class="pb-4 mb-4 border-bottom">
    <h6 class="m-0 p-0 pb-2">
      <a :href="post.file" target="_blank">{{post.title}}</a>
    </h6>
    <p v-if="!isNorm" class="m-0 p-0">{{post.description}}</p>
    <small class="meta font-weight-bold">{{formatedDate}}</small>
  </div>
</template>

<script>
export default {
  name: 'SingleFile',
  props: {
    post: Object,
    isNorm: Boolean,
  },
  computed: {
    formatedDate() {
      const monthNames = [
        '',
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ];
      return `${monthNames[this.post.month]}, ${this.post.year}`;
    },
  },
};
</script>

<style scoped>
</style>
